export default function EmptySummaryPanel(): JSX.Element {
  return (
    <article className="gt-summaryPanel">
      <div className="gt-summaryPanel__none"></div>
    </article>
  );
}
